import uniqid from 'uniqid'
import GitHubIcon from '@material-ui/icons/GitHub'
import LaunchIcon from '@material-ui/icons/Launch'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import './ProjectContainer.css'

const ProjectContainer = ({ project }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  return (
    <motion.div 
      ref={ref}
      className='project'
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
      transition={{ duration: 0.5 }}
      whileHover={{ 
        y: -10,
        boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
        transition: { duration: 0.3 }
      }}
    >
      <motion.h3
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        {project.name}
      </motion.h3>

      <motion.p 
        className='project__description'
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        {project.description}
      </motion.p>
      
      {project.stack && (
        <ul className='project__stack'>
          {project.stack.map((item, index) => (
            <motion.li 
              key={uniqid()} 
              className='project__stack-item'
              initial={{ opacity: 0, scale: 0.8 }}
              animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
              transition={{ delay: 0.4 + index * 0.05, duration: 0.3 }}
              whileHover={{ 
                scale: 1.1,
                backgroundColor: 'var(--clr-primary)',
                color: 'var(--clr-bg)',
                transition: { duration: 0.2 }
              }}
            >
              {item}
            </motion.li>
          ))}
        </ul>
      )}

      <motion.div
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        {project.sourceCode && (
          <motion.a
            href={project.sourceCode}
            aria-label='source code'
            className='link link--icon'
            whileHover={{ scale: 1.3, rotate: 10 }}
            whileTap={{ scale: 0.9 }}
          >
            <GitHubIcon />
          </motion.a>
        )}

        {project.livePreview && (
          <motion.a
            href={project.livePreview}
            aria-label='live preview'
            className='link link--icon'
            whileHover={{ scale: 1.3, rotate: -10 }}
            whileTap={{ scale: 0.9 }}
          >
            <LaunchIcon />
          </motion.a>
        )}
      </motion.div>
    </motion.div>
  )
}

export default ProjectContainer
